import { css, cx } from "@emotion/css";
import { Modal as MuiModal } from "@mui/material";
import React from "react";
export interface ModalProps {
    open: boolean;
    children: React.ReactElement;
    className?: string;
}
export function Modal({ open, className, children }: ModalProps) {
    return (<MuiModal open={open} className={cx(styles, className)}>
            {children}
        </MuiModal>);
}
const styles = css({
    "&&": {
        zIndex: "auto",
        isolation: "isolate",
    },
});
